import { ReactElement } from 'react';
import { NavigationPagePropTypes } from '../../types/propTypes/NavigationPagePropTypes';
import ApiErrorPanel from '../ApiErrorPanel/ApiErrorPanel';
import BackBar from '../BackBar/BackBar';
import Loader from '../Loader/Loader';
import './NavigationPage.css';

const NavigationPage = ({
  heading,
  pageClass,
  contentClass,
  isLoading,
  loadingDataId,
  loadingText,
  headerChild,
  displayHeaderChildWhileLoading,
  children,
  backBarLocation,
  APIError,
  supportedNonGenericErrors,
}: NavigationPagePropTypes): ReactElement => {
  const loadText = loadingText ? loadingText : 'Loading...';
  return (
    <div data-testid={'page'} className={`page--grid ${pageClass}`}>
      {backBarLocation && (
        <BackBar to={backBarLocation} visibleOverride={true} />
      )}
      <h2 className="page--heading">
        <span className="page-heading-content">{heading}</span>
        {headerChild && (!isLoading || displayHeaderChildWhileLoading) && (
          <div className="page--header-child">{headerChild}</div>
        )}
      </h2>
      {APIError && (
        <ApiErrorPanel
          error={APIError}
          containerClass={'page-error-panel'}
          includeTitle={true}
          supportedNonGenericErrors={supportedNonGenericErrors}
        />
      )}
      {isLoading ? (
        <div className="loading-container">
          <Loader dataTestId={loadingDataId} message={loadText} />
        </div>
      ) : (
        <span
          data-testid="content-panel"
          className={`page--content ${contentClass ? contentClass : ''}`}
        >
          {children}
        </span>
      )}
    </div>
  );
};

export default NavigationPage;
